
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class DspFlowWriterService {

   public static registerAndEnroll(
           axiosInstance: AxiosInstance, input: ServerData.DspFlowWebWriter.RegisterAndEnroll$Input,
           f: (output: ServerData.DspFlowWebWriter.RegisterAndEnroll$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'dspapi/dspflow/register-and-enroll',
            input.toJson()
        ).then((response) => ServerData.DspFlowWebWriter.RegisterAndEnroll$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static createSettlementRequest(
           axiosInstance: AxiosInstance, input: ServerData.DspFlowWebWriter.CreateSettlementRequest$Input,
           f: (output: ServerData.DspFlowWebWriter.CreateSettlementRequest$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'dspapi/dspflow/create-settlement-request',
            input.toJson()
        ).then((response) => ServerData.DspFlowWebWriter.CreateSettlementRequest$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

